import logs from "./logs";
import axios from "@/setup/axios-setup";
import {appVersion, APIServerPrisma2} from "@/constants/config";

export const addCommas = nStr => {
    nStr += '';
    const x = nStr.split('.');
    let x1 = x[0];
    const x2 = x.length > 1 ? '.' + x[1] : '';
    const rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
        x1 = x1.replace(rgx, '$1' + ',' + '$2')
    }
    return x1 + x2
};

export const mapOrder = (array, order, key) => {
    array.sort(function (a, b) {
        const A = a[key];
        const B = b[key];
        if (order.indexOf(A + '') > order.indexOf(B + '')) {
            return 1
        } else {
            return -1
        }
    });
    return array
};

export const getDateWithFormat = () => {
    const today = new Date();
    let dd = today.getDate();
    let mm = today.getMonth() + 1; // January is 0!

    const yyyy = today.getFullYear();
    if (dd < 10) {
        dd = '0' + dd
    }
    if (mm < 10) {
        mm = '0' + mm
    }
    return dd + '.' + mm + '.' + yyyy
};

export const getCurrentTime = () => {
    const now = new Date();
    return now.getHours() + ':' + now.getMinutes()
};

export function checkServerStatus({ store, router }) {
  store.dispatch("checkAPIServer");
  setTimeout( ()=> {
    if (store.state.status.error) {
      store.commit("appCrash", router);
    }
  }, 500);
}

export async function checkServerVersion() {
    const response = await axios.get(APIServerPrisma2 + "/version");
    return String(response.data) === appVersion;

}

export const debug = () => import("./debug");

export default {
  logs,
  debug
}
